<template>
  <div class="privacyAgreement">
    <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="隐私协议" prop="detail">
            <div style="background: #FFF" v-if="showUe">
              <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-button style="margin-left:80px" type="primary" @click="submit" :loading="submitBlock">保存</el-button>
    </div>
  </div>
</template>
<script>
import UE from "../conmom/CKEditorInformation.vue";
export default {
  components: { UE },
  data() {
    let that = this;
    return {
      showUe: false,
      ueTtext: null,
      editBlock: false,
      submitBlock: false,
      formLabelWidth: "80px",
      addForm: {
        content: null
      },
      addFormRules: {
        detail: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getPrivacyPolicySetting() {
      this.api.privacyPolicySetting.getPrivacyPolicySetting().then(result => {
        if (result.success) {
          if (result.data != null) {
            this.addForm = result.data;
            this.ueTtext = this.addForm.content;
            this.showUe = true;
            this.editBlock = true;
          } else {
            this.$nextTick(function() {
              this.showUe = true;
              console.log("1111", this.showUe);
            });
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    submit() {
      if (this.submitBlock) {
        return;
      }
      this.submitBlock = true;
      if (this.editBlock) {
        this.updatePrivacyPolicySetting();
      } else {
        this.addPrivacyPolicySetting();
      }
    },
    addPrivacyPolicySetting() {
      if (this.$refs.myQuillEditorTitle.content) {
        this.addForm.content = this.$refs.myQuillEditorTitle.content;
        this.api.privacyPolicySetting
          .addPrivacyPolicySetting(this.addForm)
          .then(result => {
            if (result.success) {
              this.submitBlock = false;
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          });
      }else{
        this.submitBlock = false;
        this.$message.error("请输入隐私协议信息")
      }
    },
    updatePrivacyPolicySetting() {
      if (this.$refs.myQuillEditorTitle.content) {
        this.addForm.content = this.$refs.myQuillEditorTitle.content;
        this.api.privacyPolicySetting
          .updatePrivacyPolicySetting(this.addForm)
          .then(result => {
            if (result.success) {
              this.submitBlock = false;
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          });
      }else{
        this.submitBlock = false;
        this.$message.error("请输入隐私协议信息")
      }
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getPrivacyPolicySetting();
  }
};
</script>
<style scoped>
.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/setting/privacyAgreement.vue